import React from "react";
import { Box, Typography } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

interface DataEntregaTransportadorProps {
  dataEntrega: any;
}

const DataEntregaTransportador: React.FC<DataEntregaTransportadorProps> = ({
  dataEntrega,
}) => {
  const isValidDate =
    typeof dataEntrega === "string" && dataEntrega.trim() !== "";

  const formatarData = (dataISO: any): string => {
    if (!dataISO || typeof dataISO !== "string") return "--";
    const data = new Date(dataISO);
    if (isNaN(data.getTime())) return "--";
    return data.toLocaleDateString("pt-BR");
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      //   gap={2}
      style={{ marginTop: "5px" }}
    >
      <LocalShippingIcon color="primary" fontSize="large" />
      <Typography
        variant="subtitle2"
        sx={{
          mb: 0.5,
          color: "#333",
          textAlign: "left",
          width: { md: "44%", xl: "47%" },
          ml: 1,
        }}
      >
        Data de Entrega Transportador
      </Typography>
      <Box sx={{ width: "50%" }}>
        <Box
          sx={{
            height: "36px",
            border: "1px solid rgba(0, 0, 0, 0.23)",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            px: 2,
          }}
        >
          {isValidDate ? (
            <Typography sx={{ textAlign: "center" }}>
              {formatarData(dataEntrega!)}
            </Typography>
          ) : (
            <Typography color="text.secondary" variant="body2">
              Nenhuma data informada
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default DataEntregaTransportador;
